export default __webpack_public_path__ + "static/media/pipeline-protection-system-2.e5f09f4a.jpg";